import React, {useState} from 'react';
import AdminVerkstedCard from '../adminVerkstedCard';
import EgenDropdownCSS from './egenDropdown.module.css';

function EgenAdminDropdown({ title, verksteder }){

    const [isOpen, setIsOpen] = useState(false);


    return(
        <div className={EgenDropdownCSS.container}>
            <div className={EgenDropdownCSS.ddTrigger} onClick={()=>{setIsOpen(!isOpen)}}>
                {title}
            </div>
            <div className={`${EgenDropdownCSS.ddContent} ${isOpen ? EgenDropdownCSS.active : ''}`}>
                <div className={EgenDropdownCSS.cardDeck}>
                    {verksteder.map((verksted, index) => (
                        <AdminVerkstedCard
                            key={index}
                            verksted={verksted}
                            id={verksted.attributes.id}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default EgenAdminDropdown;